var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertGray3232 = function SvgAlertGray3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 1.5,
    y: 1.5,
    stroke: "#C6C7C8",
    strokeWidth: 3,
    rx: 14.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C7C8",
    d: "M14.5 8.5h3v10h-3zM14.5 20.5h3v3h-3z"
  })));
};
export default SvgAlertGray3232;